import React, {CSSProperties, ReactNode} from "react";
interface IBasicSection{
    h1?: ReactNode;
    h2?:ReactNode;
    children?:ReactNode;
    bgType?:string;
    style?:CSSProperties;
    id?:string;
}
export default (props:IBasicSection)=>{
    return (
        <section className={'section '+(props.bgType ?? "white-section")} style={props.style} id={props.id}>
            {props.h1 && <h1 className="font1 default-animation">{props.h1}</h1>}
            {props.h2  && <h2 className={'font2 default-animation'}>
                {props.h2}
            </h2>}
            {props.children}
        </section>
    )
}
